import {
  ACTIVE_ORGANIZATION_COOKIE_NAME,
  ACTIVE_ORGANIZATION_STORAGE_KEY,
} from "@/constants/storage-keys";

const ACTIVE_ORGANIZATION_COOKIE_MAX_AGE_DAYS = 365;

const setClientCookie = (name: string, value: string, maxAgeDays: number): void => {
  const expires = new Date(Date.now() + maxAgeDays * 864e5).toUTCString();
  const secure = process.env.NODE_ENV === "production" ? "; Secure" : "";
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Strict${secure}`;
};

const clearClientCookie = (name: string): void => {
  const secure = process.env.NODE_ENV === "production" ? "; Secure" : "";
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Strict${secure}`;
};

/** Persists active org id for client state (localStorage) and proxy (cookie). */
export const persistActiveOrganizationId = (id: string): void => {
  try {
    localStorage.setItem(ACTIVE_ORGANIZATION_STORAGE_KEY, id);
  } catch {
    /* ignore */
  }
  setClientCookie(ACTIVE_ORGANIZATION_COOKIE_NAME, id, ACTIVE_ORGANIZATION_COOKIE_MAX_AGE_DAYS);
};

export const clearPersistedActiveOrganizationId = (): void => {
  try {
    localStorage.removeItem(ACTIVE_ORGANIZATION_STORAGE_KEY);
  } catch {
    /* ignore */
  }
  clearClientCookie(ACTIVE_ORGANIZATION_COOKIE_NAME);
};
